export default {
	project_name: 'Academia Protecto',
	company_agency: 'Entreprise / Magasin',
	add_new_company: 'Ajouter une nouvelle entreprise / magasin',
	no_company_agency_found: "Entreprise / Magasin no encontrada",
}
